import { fetchUserData, fetchUserDetails, handleSeviceTypes } from "../helpers"
import trackEvent from "../helpers/trackAnalytics"
import pubsub from "@viewlift/pubsub"
import { publishHBAModal } from "./Events/hba.events"
import { publishPlansLoaded } from "./Events/plans.events"
import { publishTveStatus } from "./Events/tve.events"
import { publishAppLoading, publishErrorUpdate, publishUserCreated } from "./Events/utils.events"
import { createAccountViaEmailPhone } from "./LoginV2/Helpers/login"
import { fetchCheckoutStore, updateCheckoutStore } from "./utils/CheckoutStore"
import { fetchCurrentPlan } from "./PlansWrapper/helper"
import { fetchUserObject } from "./MonetisationModule02/Stripe/helper"
import { parseJSON } from "./utils/parseJSON"
import { ANALYTICS } from "../helpers/analyticsMap"
import { ANALYTICSEVENTS } from "./LoginV2/Helpers/analyticsMap"
import logger from "../logger";
import { publishMonetisationcontinue } from "./Events/monetisation.events"
import localforage from 'localforage'

let allPlans = []
const updateSelectedPlans = (plan, plans, contentDetails = []) => {
  //stores the plan to session
  // let currentStoredPlan = parseJSON(sessionStorage.getItem("currentPlan"))
  // if (currentStoredPlan) {
  //   publishPlansLoaded(plan) //Broadcasting plans is loaded
  //   updateCheckoutStore({ plansDetail: { currentSelectedPlan: currentStoredPlan } })
  //   return
  // }
  // allPlans = allPlans?.length ? allPlans : plans
  sessionStorage.setItem('currentPlan', JSON.stringify(plan))
  setTransactionDataInStorage(plan, contentDetails);
  publishPlansLoaded(plan) //Broadcasting plans is loaded
  // pubsub.publish('selected-plan-update', plan) // to syncronise the payment and plans selection
  updateCheckoutStore({ plansDetail: { currentSelectedPlan: plan, allPlans : plans } }) //Imp update the required section in store
}

const setTransactionDataInStorage = (plan, contentDetails) => {
  const planType = plan?.type?.toUpperCase();
  const isPurchase = planType?.includes('SVOD') ? false : true
  const purchaseType = planType?.includes('SVOD') ? 'Svod' : planType?.includes('BUY') ? 'Buy' : 'Rent'
  localforage.setItem('transactionData', {
    isPurchase,
    planDetails: plan,
    purchaseType,
    contentDetails
  });
}

const isTveEnabled = () => {
  let serviceTypes = handleSeviceTypes()
  if (serviceTypes?.TVE) return true
  return false
}

const handleUpdatedPlan = ({ planDetails, plan , plans, contentDetails}) => {
  console.log("pdssad",plan)
  if (planDetails?.id) { // if selected cta is not a tve or more options cta
    updateSelectedPlans(plan, plans, contentDetails)
  }
  if (planDetails?.type === "TVE") {
    publishTveStatus(true) // choose b/w tve or subscription
    return
  }
  publishTveStatus(false)
}

const proceedOnboarding = async (hbaDisabled) => {
  //check if user is available through authentication store
  let { userId } = await fetchUserDetails()
  let isCheckout = true
  if (!userId) {
    //call Create Account
    fetchCheckoutStore().then((checkoutStore) => {
      if (!checkoutStore?.userDetails) {
        publishAppLoading(false)
      //throw error here
      return 
      }
      let userDetails = checkoutStore?.userDetails
      const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
      let eventData = {
        "pageUrl": checkoutInitPageDetails?.pageUrl
      }
      if (!userDetails?.userId) {
        createAccountViaEmailPhone(userDetails, isCheckout).then((res) => {
          // user creation
          userDetails?.e ? (eventData.email = userDetails?.e, eventData.registeredVia = "email") : eventData.phoneNumber = (userDetails?.p, eventData.registeredVia = "phone number")
          let analyticsEventData={ename: ANALYTICSEVENTS.CHECKOUT_USER_CREATE_SUCCESS, data: eventData};
          handleStatusGaCalls({eventName : 'checkout_user_create_success',subSection : null, type : 'login', reason : 'true', status : null, action : 'Login Success', paymentStatus : null,eventCategory : 'Checkout'})
          pubsub.publish('user-analytics',analyticsEventData)
          handleStatusGaCalls({eventName : 'signup_success',subSection : 'login', type : 'success', reason : null, status : null, action : 'Success', paymentStatus : null,eventCategory : 'Authentication'})
          userDetails?.e ? pushStepToFlow("email added") : pushStepToFlow("phone number")
          let analyticsData={ename:ANALYTICS.USER_CREATED,data:res};
          pubsub.publish('user-analytics',analyticsData)
          trackEvent('USER_CREATED', res,null)
          let status = res?.status
          if (!status) {
            logger(res)
            publishAppLoading(false)
            return
          }
          publishUserCreated({status : status ? true : false})
          if(status){
            fetchUserData().then((res) => {
              if(res?.userId){
              //check for HBA
              if (hbaDisabled) {
                publishMonetisationcontinue(true)
              }else {
              publishAppLoading(false)
              publishHBAModal(true) // it'll handle whether to call monetisation on basis of location is enabled or not
              } 
              }else{
                publishErrorUpdate("Unable to fetch user data")
              }
            }).catch((err) => {
              logger(err)
              publishErrorUpdate("Unable to fetch user data")
              publishAppLoading(false)
            })
          }
          
        }).catch((e) => {
          userDetails?.e ? (eventData.email = userDetails?.e, eventData.registeredVia = "email") : eventData.phoneNumber = (userDetails?.p, eventData.registeredVia = "phone number")
          let analyticsEventData={ename: ANALYTICSEVENTS.CHECKOUT_USER_CREATE_FAILURE, data: eventData};
          handleStatusGaCalls({eventName : 'checkout_user_login_failure',subSection : null, type : 'login', reason : 'true', status : null, action : 'Login Failure', paymentStatus : null,eventCategory : 'Checkout'})
          pubsub.publish('user-analytics',analyticsEventData)
          handleStatusGaCalls({eventName : 'signup_failure',subSection : 'login', type : 'failure', reason : e?.message, status : null, action : 'Failure', paymentStatus : null,eventCategory : 'Authentication'})
          publishErrorUpdate("Error while creating account")
          publishAppLoading(false)
        })
      }else {
        if (!window?.isUserSseEvent) {
          publishUserCreated({status : true })
        }
        if (hbaDisabled) {
          publishMonetisationcontinue(true)
        }else {
          publishAppLoading(false)
          publishHBAModal(true) // it'll handle whether to call monetisation on basis of location is enabled or not
        }
      }
    }).catch((e) => {
      // publish error here
    publishAppLoading(false)
    })
  }else {
    if (hbaDisabled) {
      publishMonetisationcontinue(true)
  }else {
    publishAppLoading(false)
    publishHBAModal(true)
  }
  }
}

let flowSteps = []
const pushStepToFlow = (step) => {
  if(!flowSteps.includes(step))
  flowSteps.push(step)
}

const handleStatusGaCalls = async ({type,reason,status,action,paymentStatus,eventCategory,subSection,eventName,section,additionalLabel}) => {

  if (eventName == 'checkout_init' ) {
    sessionStorage.setItem('checkout-initiate',JSON.stringify(true))
  }else if (eventName == "checkout_cancellation") {
    sessionStorage.setItem('checkout_cancellation',JSON.stringify(false))
    sessionStorage.getItem('checkout-initiate') ? sessionStorage.removeItem('checkout-initiate') : ''
  }else if (eventName == 'checkout_success') {
    sessionStorage.getItem('checkout-initiate') ? sessionStorage.removeItem('checkout-initiate') : ''
    sessionStorage.getItem('checkout_cancellation') ? sessionStorage.removeItem('checkout_cancellation') : ''
    sessionStorage.setItem('checkout_success',JSON.stringify(false))
  }
  let userLocation = parseJSON(localStorage.getItem('locationCoords'))
  if(userLocation){
    userLocation['origip'] ? delete userLocation['origip'] : '' //This violates GDPR/Google terms 
  }
  let event_name = eventName
  let userData = await fetchUserObject()
  let plan = fetchCurrentPlan()
  if(!plan) {
    let {plansDetail} = await fetchCheckoutStore()
    if (plansDetail?.currentSelectedPlan) {
      plan = plansDetail?.currentSelectedPlan
    }
  }
  let payload = {
    logged_in_status : userData?.userId ? 'Yes'  : 'No',
    subscribed_status : userData?.isSubscribed ? 'Yes' : 'No',
    // email : userData?.email, //This violates GDPR/Google terms 
    // mobile : userData?.mobile, // Yes, collecting and sending mobile numbers to Google Analytics 4 (GA4) violates both GDPR and Google's Terms of Service,
    monetizationType : ((plan?.type) || (plan.monetizationModel)),
    currencycode : ((plan?.currency) || (plan?.planDetails && plan?.planDetails[0]?.recurringPaymentCurrencyCode)),
    subscription_plan : ((plan?.title) || (plan?.planDetails && plan?.planDetails[0]?.title)),
    // user_location : userLocation ? userLocation : null, //This violates GDPR/Google terms 
    event_category : eventCategory,
    event_action : action,
    event_value : ((plan?.amount) || (plan?.planDetails && plan?.planDetails[0]?.recurringPaymentAmount)) || null,
  }
  if (reason) {
    payload[`event_label1`] = reason
  }
  if (status) {
    payload[`event_label2`] = status
  }
  if (section) {
    payload.section = section
  }
  if (subSection) {
    payload.sub_section = subSection
  }
  if (additionalLabel) {
    payload[`event_label3`] = additionalLabel
  }
  if(eventName == 'checkout_init' || eventName == "checkout_cancellation" || eventName == 'checkout_success' || eventName == 'checkout_error'){
    let ecommercePayload = {
      ecommerce: {
        currencycode : ((plan?.currency) || (plan?.planDetails && plan?.planDetails[0]?.recurringPaymentCurrencyCode)),
        value: ((plan?.amount) || (plan?.planDetails && plan?.planDetails[0]?.recurringPaymentAmount)), 
        items: [payload],
      }
    }
    trackEvent(event_name, ecommercePayload,null)
  } else {
    trackEvent(event_name,payload,null)
  }
}

const triggerUserMergeEvent = (isUserExsist) => {
  const checkoutInitPageDetails = JSON.parse(sessionStorage.getItem('checkoutInitPageData'))
  let userMergeEventData = {
    "pageUrl": checkoutInitPageDetails?.pageUrl,
    "mergeType": isUserExsist ? "Existing user" : "New users"
  }
  let analyticsData={ename:ANALYTICSEVENTS.USER_MERGE, data: userMergeEventData};
  pubsub.publish('user-analytics',analyticsData)
}

export { updateSelectedPlans, isTveEnabled, allPlans, handleUpdatedPlan, proceedOnboarding, flowSteps, pushStepToFlow, handleStatusGaCalls, triggerUserMergeEvent, setTransactionDataInStorage }
